import React, {Component, Fragment} from "react";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import { Container, Row, Col,InputGroup, InputGroupAddon, Button, Input, UncontrolledTooltip, FormGroup, Label} from 'reactstrap';
import http from "../../../../services/HttpService";
import {Link} from "react-router-dom";
import Route from "../../../../Routes";
import Loading from "../../../includes/Loading";
import i18next from 'i18next';
import { Translation } from "react-i18next";

import LayoutDashboard from "../../../../views/layout/Dashboard";
import {layout} from "../../../../../ts-helpers/decorators";

@layout(LayoutDashboard)
@(connect((state) => {
    return { };
}) as any)

export default class AllIndustries extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    state = {
        industries: [],
        loading:true,
    };

    constructor(props: Map<any, any>) {
        super(props);
    }

    componentDidMount() {
        this.getData();
        this.props.onRef(this);
    }

    @autobind
    getData(){
        http.get('/industries/dashboard/all')
            .then(response => response.json())
            .then((data) => {
                this.setState({
                    industries:data,
                    loading:false,
                });
            });
    }

    @autobind
    changeLanguage(e) {
        const lng = e.currentTarget.dataset.lang
        this.setState({ lng: lng }, () => {
            i18next.changeLanguage(lng);
            this.props.changeLang();
        });
    }

    @autobind
    langTranslation(e){
        return <Translation>{t => t(`${e}`)}</Translation>
    }

    render() {
        const {loading, industries}=this.state;
        return(
            <Container fluid>
                <Row>
                    <Col xs={12}>
                        <h4 className="header-title m-t-0 m-b-20">Industries!</h4>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-left">
                        <Link to={Route.toUrl("dashboard_industry_add")}
                              className="section_link_add_dashboard"><i className="fa fa-plus" /> Add
                        </Link>
                    </Col>
                </Row>
                <hr className="dashboard_my_hr"/>
                {
                    loading ? <Container><Row><Col className="text-center"><Loading isLoading={loading} icon="loadDashboardInfo"/></Col></Row></Container> :
                        <Fragment>
                                {industries.map((industrie, i) => (
                                    <Row key={i}>

                                        <Col className="col-sm-6 col-sm-offset-3 level_dashboard_block">
                                            <Col className="col-xs-6 col-sm-6 text-left level_title_dashboard">
                                                {industrie.i_name}
                                                {
                                                    industrie.i_active == true ?
                                                        <div className="dashboard_all_industries_active">Active</div>
                                                        :
                                                        <div className="dashboard_all_industries_inactive">Inactive</div>
                                                }
                                            </Col>
                                            <Col className="col-xs-6 col-sm-6 text-right level_link_block_dashboard">
                                                <Link
                                                    to={Route.toUrl('dashboard_industry_edit', {industryId: industrie._id})}
                                                    className="section_link_edit_dashboard" title="Edit">
                                                    <i className="fa fa-pencil"/>
                                                </Link>
                                            </Col>
                                        </Col>

                                    </Row>
                                ))}
                        </Fragment>
                }
            </Container>
        );

    }
}
